import React, { useCallback } from 'react';

import { Icon } from '@rbilabs/components-library';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import AccountLayout from 'components/layout/account';
import { BackArrowLink } from 'components/navigation/back-arrow';
import { useFeatureMemberships } from 'hooks/use-feature-memberships';
import { routes } from 'utils/routing';

import { MembershipListElement } from './styled';

const AccountMemberships = () => {
  const { formatMessage } = useIntl();
  const { featureMemberships } = useFeatureMemberships();
  const navigate = useNavigate();

  const handleClickMembership = useCallback(
    selectedMembership => {
      navigate(formatMessage({ id: 'routes.membershipDetails' }), {
        state: { selectedMembership },
      });
    },
    [navigate, formatMessage]
  );

  return (
    <AccountLayout header={formatMessage({ id: 'memberships' })}>
      <BackArrowLink to={routes.account} />
      {featureMemberships?.liveMemberships?.map((membership, idx: number) => (
        <MembershipListElement
          key={membership?._id || idx}
          onClick={() => handleClickMembership(membership?._id)}
        >
          {membership?.membershipName}
          <Icon
            icon="next"
            color="icon-default"
            width="16px"
            aria-hidden
            data-testid="icon-test-id"
          />
        </MembershipListElement>
      ))}
    </AccountLayout>
  );
};

export default AccountMemberships;
